module.exports = __webpack_public_path__ + "img/earth.3eac7e22.png";